<template>
    <div class="engineering">
        <el-container>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="engineerList"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column label="项目部" prop="deptName" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="项目" prop="projectName" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="细目名称-总包" prop="subCategoryName" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="细目编码" prop="subCategoryNo" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="备份时间" prop="createTime" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="uploadTxt(scope.row)">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import {exportMiddleHistoryService, getMiddleHistroyService} from "../../../services/engineering";
    import {exportExcelService2} from "../../../services/allContractServices";

    export default {
        name: "historyEdition",
        data(){
            return {
                dataForm:{
                    pageIndex: 1,
                    pageSize: 10,
                },
                total: 0,
                middleId: '',
                engineerList: [],
            }
        },
        methods: {
            onActive(menuCode) {
                this.middleId = this.tabRouteParam.id
                this.getFrontHistroy()
            },
            //查询历史版本
            getFrontHistroy(){
                let params = {
                    middleId: this.middleId
                }
                getMiddleHistroyService(params).then( res => {
                    if(res.code == 10000000){
                        this.engineerList = res.data;
                        this.total = res.total;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            uploadTxt(row){
                let params = {
                    middleId: row.id
                }
                exportMiddleHistoryService(params).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getFrontHistroy();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getFrontHistroy();
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
</style>
